import NoteIcon from "@assets/icons/note.svg";
import LockClosedIcon from "@assets/icons/lock-closed.svg";

import type { INoteTag } from "@interfaces/tag.interface";
import { OrganizationLogo } from "@ui/Logos";
import { TagLabel } from "@ui/Content";

type Props = {
  item: INoteTag;
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionNote = ({ item, ...rest }: Props) => {
  return (
    <div {...rest} className="flex min-w-0 cursor-pointer items-center gap-2 p-2">
      <NoteIcon width={20} height={20} className="flex-shrink-0 dark:text-gray-400" />
      <TagLabel>{item.title}</TagLabel>
      {item.access === "Private" ? (
        <LockClosedIcon width={20} height={20} className="text-content-secondary" />
      ) : (
        <OrganizationLogo />
      )}
    </div>
  );
};
